export default __webpack_public_path__ + "static/media/restaumatic-sm-light.6c0be3ea.svg";